import React, { useContext, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import AppContext from "../../container/context";
import ActionTable from "../../components/table/ActionTable";
import { Button, Dialog, DialogActions, DialogTitle, Grid, TextField, Fab } from "@mui/material";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";

const dataAtual = new Date();
const mesAtual = dataAtual.getMonth() + 1;
const anoAtual = dataAtual.getFullYear();

export default function Edicao({
  pedido,
  elemento,
  fecharEdicao,
  fecharSelecaoEdicao,
  recarregar
}) {
  const { notification } = useContext(AppContext);
  const [dadosReparcelamento, setDadosReparcelamento] = useState({});
  const [catalogo, setCatalogo] = useState([]);
  const [buscaProduto, setBuscaProduto] = useState({ nome: "" });
  const [produto, setProduto] = useState({ nome: "" });
  const [insercaoItem, setInsercaoItem] = useState(false);
  const [dadosFrete, setDadosFrete] = useState({});
  const [confirmarValorFrete, setConfirmarValorFrete] = useState(false);

  const encerrarEdicao = () => {
    fecharEdicao();
    fecharSelecaoEdicao();
  }

  const iniciarInsercaoItem = () => {
    setInsercaoItem(true);
  }

  const atualizarValorFrete = () => {
    const dados = {
      pedidoId: pedido.id,
      freteValor: Number(dadosFrete.freteValor) * 100,
      freteServico: dadosFrete.freteServico,
    };

    api
      .post("pedidos/atualizarFrete", dados)
      .then((res) => {
        notification("success", "Frete atualizado com sucesso.");
        fecharEdicao();
        fecharSelecaoEdicao();
        recarregar();
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Valor de frete inválido");
          case 2:
            return notification("error", "Pedido com pagamento já faturado/boleto gerado");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const salvarFrete = (form) => {
    setDadosFrete(form);
    setConfirmarValorFrete(true);
  };

  const fFrete = {
    title: "Novo Frete",
    form: {
      freteValor: {
        label: "Valor",
        type: "number",
        space: 6,
        value: dadosFrete.freteValor,
      },
      freteServico: {
        label: "Serviço",
        type: "text",
        space: 6,
        value: dadosFrete.freteServico,
      },
    },
    submit: {
      label: "salvar",
      action: salvarFrete,
      // action: () => setConfirmarValorFrete(true),
    },
    close: {
      label: "fechar",
      action: () => fecharEdicao(),
    },
  };

  const atualizarParcelamento = (form) => {
    setDadosReparcelamento(form);
    const dataAtual = new Date();

    const dataReferenciaVencimento = new Date(form.ano, form.mes, -1, 0, 0, 0);

    if (dataReferenciaVencimento < dataAtual) {
      return notification(
        "error",
        "O período de vencimento não pode ser inferior ao atual"
      );
    }

    const novoParcelamento = {
      pedidoId: pedido.id,
      anoInicio: form.ano,
      mesInicio: form.mes,
      qtdParcelas: form.qtdParcelas,
    };

    api
      .post("pedidos/atualizarParcelamento", novoParcelamento)
      .then(() => {
        notification("success", "Parcelamento alterado com sucesso.");
        recarregar();
        fecharEdicao();
        fecharSelecaoEdicao();
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification(
              "error",
              "Escola com fatura já fechada para o mês/ano de início do pagamento"
            );
          case 2:
            return notification("error", "Quantidade de parcelas inválida");
          case 3:
            return notification("error", "Mês/ano de início inválido");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };
  
  const fParcelamento = {
    title: "Parcelamento",
    form: {
      valorPendente: {
        label: 'Total (R$) com pagamento pendente',
        type: 'text',
        value: (pedido.valorPendente/100).toFixed(2),
        space: 3,
        readOnly: true
      },
      ano: {
        label: "Ano de vencimento da 1ª parcela",
        type: "number",
        value: dadosReparcelamento.ano
          ? dadosReparcelamento.ano
          : mesAtual === 12
          ? anoAtual + 1
          : anoAtual,
        required: true,
        space: 3,
      },
      mes: {
        label: "Mês de vencimento da 1ª parcela",
        type: "number",
        value: dadosReparcelamento.mes
          ? dadosReparcelamento.mes
          : mesAtual === 12
          ? 1
          : mesAtual + 1,
        required: true,
        space: 3,
      },
      qtdParcelas: {
        label: "Quantidade de parcelas",
        type: "number",
        value: dadosReparcelamento.qtdParcelas
          ? dadosReparcelamento.qtdParcelas
          : 0,
        required: true,
        space: 3,
      }
    },
    submit: {
      label: "Confirmar",
      action: atualizarParcelamento,
    },
    close: {
      label: "fechar",
      action: () => fecharEdicao(),
    },
  };

  // Incluir Item

  const buscarProdutos = (form) => {
    setBuscaProduto(form);

    const dadosBusca = {
      escolaId: pedido.escolaId,
      filtros: {
        nome: form.nome,
        categoriaId: 0,
        produtoPerto: 0,
      },
    };

    api.get("produtos/catalogoEscola", dadosBusca).then((catalogo) => {
      catalogo.forEach((c) => (c.valorVenda = (c.valorVenda / 100).toFixed(2)));
      setCatalogo(catalogo);
    });
  };

  const fBuscaItem = {
    form: {
      nome: {
        label: "Nome",
        type: "text",
        value: buscaProduto.nome,
      },
    },
    title: "Buscar produto",
    submit: {
      label: "Buscar",
      action: buscarProdutos,
    },
    close: {
      label: "fechar",
      action: () => fecharEdicao(),
    },
  };

  const tCatalogo = {
    title: "Produtos",
    array: catalogo,
    columns: [
      {
        name: "nome",
        label: "Produto",
      },
      {
        name: "categoriaNome",
        label: "Categoria",
      },
      {
        name: "valorVenda",
        label: "Valor de catalogo",
      },
    ],
    onLineClick: (produtoIncluir) => setProduto(produtoIncluir),
  };

  const incluirProduto = (form) => {
    // if (!form.valor || form.valor <= 0) {
    //   if (!confirm("O produto será incluído sem cobrança. Deseja continuar?"))
    //     return;
    // }

    const produtoIncluirSalvar = {
      pedidoId: pedido.id,
      produtoId: produto.id,
      quantidade: form.quantidade,
      valorCentavos: form.valor ? form.valor * 100 : 0,
    };

    api
      .put("pedidos/inserirItem", produtoIncluirSalvar)
      .then(() => {
        notification("success", "Produto incluído com sucesso.");
        recarregar();
        fecharEdicao();
        fecharSelecaoEdicao();
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Quantidade inválida");
          case 2:
            return notification("error", "Valor inválido");
          case 3:
            return notification("error", "O pedido já contém o item");
          case 4:
            return notification("error", "Pedido com pagamento já faturado/boleto gerado");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const fProdutoIncluir = {
    form: {
      nome: {
        label: "Componente",
        type: "component",
        space: 6,
        value: (
          <div>
            <h4>Produto</h4>
            <p>{produto.nome}</p>
          </div>
        ),
      },

      quantidade: {
        label: "Quantidade",
        type: "number",
        value: produto.quantidade,
        required: true,
        space: 3,
      },
      valor: {
        label: "Valor de catalogo",
        type: "number",
        value: produto.valorVenda ? produto.valorVenda : 0,
        required: true,
        space: 3,
      },
    },
    title: "Produto a incluir",
    submit: {
      label: "Confirmar",
      action: incluirProduto,
    },
    close: {
      label: "fechar",
      action: () => fecharEdicao(),
    },
  };

  return (
    <div>
      {insercaoItem ?
        <>
          {produto.id ? (
            <Form formData={fProdutoIncluir} />
          ) : (
            <>
              <Form formData={fBuscaItem} />
              <ActionTable structure={tCatalogo} />
            </>
          )}
        </>
      :
        <>
          {elemento === "FRETE" && <Form formData={fFrete} />}

          {elemento === "PARCELAS" && <Form formData={fParcelamento} />}

          {elemento === 'ITENS' &&
            <ListaEdicaoItens 
              pedidoId={pedido.id} 
              itens={pedido.itens} 
              iniciarInsercaoItem={iniciarInsercaoItem}
              recarregar={recarregar} 
              encerrarEdicao={encerrarEdicao}
            />
          }
        </>
      }

      <Dialog
        open={confirmarValorFrete}
        onClose={() => setConfirmarValorFrete(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Confirma a alteração no valor do frete?
        </DialogTitle>
        <DialogActions>
          <Button onClick={() => atualizarValorFrete()} autoFocus>
            Confirmar
          </Button>
          <Button onClick={() => setConfirmarValorFrete(false)}>
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const ListaEdicaoItens = ({pedidoId, itens, iniciarInsercaoItem, recarregar, encerrarEdicao}) => {
  const { confirm, notification} = useContext(AppContext);
  const [produtosEditados, setProdutosEditados] = useState([]);

  const atualizarQuantidade = (qtd, item) => {
    const produtosEditadosAtualizar = [...produtosEditados];

    const itemEdicao = produtosEditadosAtualizar.find(produto => produto.produtoId === item.produtoId);

    if(item.pedidoItemQtd === +qtd && itemEdicao?.valor === item.pedidoItemValor) return descartarEdicao(item.produtoId);

    if(itemEdicao){
      itemEdicao.quantidade = +qtd;      
    } else {
      produtosEditadosAtualizar.push({
        produtoId: item.produtoId,
        quantidade: +qtd,
        valor: item.pedidoItemValor/100
      });
    }

    setProdutosEditados(produtosEditadosAtualizar);
  }

  const atualizarValor = (valor, item) => {
    const produtosEditadosAtualizar = [...produtosEditados];

    const itemEdicao = produtosEditadosAtualizar.find(produto => produto.produtoId === item.produtoId);

    if(item.pedidoItemQtd === itemEdicao?.quantidade && +valor*100 === item.pedidoItemValor) return descartarEdicao(item.produtoId);

    if(itemEdicao){
      itemEdicao.valor = +valor;      
    } else {
      produtosEditadosAtualizar.push({
        produtoId: item.produtoId,
        quantidade: item.pedidoItemQtd,
        valor: +valor
      });
    }

    setProdutosEditados(produtosEditadosAtualizar);
  }

  const confirmarRemocao = (produtoId) => {
    confirm({
      title: "Confirma a remoção do item no pedido?",
      label: "",
      onConfirm: () => removerProduto(produtoId),
    });
  }

  const removerProduto = (produtoId) => {
    const produtoRemoverSalvar = {
      pedidoId,
      produtoId
    };

    api
      .delete("pedidos/removerItem", produtoRemoverSalvar)
      .then(() => {
        notification("warning", "Produto removido.");
        recarregar();
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", " Item inexistente no pedido");
          case 2:
            return notification("error", "Pedido com pagamento já faturado/boleto gerado");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const salvarEdicao = (produtoEditado) => {
    const produtoAtualizarSalvar = {
      pedidoId,
      produtoId: produtoEditado.produtoId,
      quantidade: produtoEditado.quantidade,
      valorCentavos: produtoEditado.valor ? +produtoEditado.valor * 100 : 0,
    };

    api
      .post("pedidos/atualizarItem", produtoAtualizarSalvar)
      .then(() => {
        notification("success", "Produto atualizado com sucesso.");
        recarregar();
        descartarEdicao(produtoEditado.produtoId);
      })
      .catch((err) => {
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Quantidade inválida");
          case 2:
            return notification("error", "Valor inválido");
          case 3:
            return notification("error", "Item inexistente no pedido");
          case 4:
            return notification("error", "Pedido com pagamento já faturado/boleto gerado");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const descartarEdicao = produtoId => {
    const produtosEditadosAtualizar = [...produtosEditados.filter(produto => produto.produtoId !== produtoId)];

    setProdutosEditados(produtosEditadosAtualizar);
  }

  return(
    <div>      
      <Grid container style={{backgroundColor: 'white', padding: 10, marginTop: 10}}>
        <Grid item>
          <h4>Itens/produtos</h4>
        </Grid>
        <Grid item>
          <Fab
            size="small"
            color="primary"
            aria-label="add"
            onClick={iniciarInsercaoItem}
            style={{marginLeft: 10}}
            title={"Novo item"}
          >
            <AddIcon style={{ color: "white" }} />
          </Fab>
        </Grid>
      </Grid>
      {itens.map((item, key) => {
        const produtoEditado = produtosEditados.find(produto => produto.produtoId === item.produtoId);

        return(
          <Grid key={key} container style={{backgroundColor: 'white', padding: 10, marginTop: 5}}>
            <Grid item xs={5}>
              <div>
                {produtoEditado ? <h4>{item.produtoNome} (editado)</h4> : <h4>{item.produtoNome}</h4>}                
              </div>
            </Grid>
            <Grid item xs={3}>
              <TextField
                id="outlined-basic"
                type="number"
                variant="outlined"
                label="Quantidade"
                value={produtoEditado ? produtoEditado.quantidade : item.pedidoItemQtd}
                onChange={(e) => atualizarQuantidade(e.target.value, item)}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                id="outlined-basic"
                type="number"
                variant="outlined"
                label="Valor unitário (R$)"
                value={produtoEditado ? 
                  produtoEditado.valor :
                  (item.pedidoItemValor ? (item.pedidoItemValor/100).toFixed(2) : 0)
                }
                onChange={(e) => atualizarValor(e.target.value, item)}
              />
            </Grid>
            <Grid item xs={1}>
              <Fab
                size="small"
                style={{backgroundColor: 'red'}}
                aria-label="add"
                onClick={() => confirmarRemocao(item.produtoId)}
                title="Remover produto"
              >
                <RemoveIcon style={{ color: "white" }} />
              </Fab>
            </Grid>
            {produtoEditado &&
              <Grid item xs={12}>
                <Grid container style={{backgroundColor: '#f6ffc2', padding: 5, marginTop: 5}}>
                  <Grid item xs={5}>
                    <Button
                      color="primary"
                      variant="contained"
                      style={{margin: 5, color: 'white'}}
                      onClick={() => salvarEdicao(produtoEditado)}
                    >
                      Salvar edição
                    </Button>
                    <Button
                      color="secondary"
                      variant="contained"
                      style={{margin: 5, color: 'white'}}
                      onClick={() => descartarEdicao(item.produtoId)}
                    >
                      Descartar edição
                    </Button>
                  </Grid>
                  <Grid item xs={3}>
                    <span>{item.pedidoItemQtd} {'>'} <b>{produtoEditado.quantidade}</b></span>
                  </Grid>
                  <Grid item xs={3}>
                    <span>{(item.pedidoItemValor/100).toFixed(2).replace('.', ',')} {'>'} <b>{(produtoEditado.valor).toFixed(2).replace('.', ',')}</b></span>
                  </Grid>
                </Grid>
              </Grid>
            }
          </Grid>
        )
      })}
      <div container style={{backgroundColor: 'white', padding: 10, marginTop: 5}}>
        <Button
          color="secondary"
          variant="contained"
          style={{margin: 5, color: 'white'}}
          onClick={encerrarEdicao}
        >
          Sair do modo edição
        </Button>
      </div>
    </div>
  )
}